"use client";

import { useEffect, useState } from "react";
import { useFeatureFlagVariantKey } from "@posthog/react";
import { DEFAULT_FLAG_VALUES } from "@/lib/ab-test";

// ============================================================================
// Hook A/B — anti-flash
//   `ready` passe à true UNIQUEMENT quand la variante est connue (ou au timeout).
//   Tant que `ready` est false, le composant masque l'UI variant-dépendante pour
//   éviter le "flash" de la variante control avant la bonne variante (FOUC A/B).
// ============================================================================

// Délai max avant de révéler l'UI même si PostHog n'a pas répondu
// (AdBlock / offline) → on affiche alors la variante par défaut.
const REVEAL_TIMEOUT_MS = 1200;

export const useABTest = (flagKey: string) => {
  const posthogVariant = useFeatureFlagVariantKey(flagKey);
  const [override, setOverride] = useState<string | null>(null);
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    // Preview/QA : ?ab=<variant> force la variante affichée (ex. ?ab=obsolescence).
    const forced = new URLSearchParams(window.location.search).get("ab");
    if (forced) setOverride(forced);
    const t = setTimeout(() => setTimedOut(true), REVEAL_TIMEOUT_MS);
    return () => clearTimeout(t);
  }, []);

  const resolved = override !== null || posthogVariant !== undefined;
  const variant =
    override ?? (posthogVariant as string) ?? DEFAULT_FLAG_VALUES[flagKey] ?? "control";

  return {
    variant,
    isControl: variant === "control",
    // prêt à afficher quand PostHog a répondu OU au timeout de secours
    ready: resolved || timedOut,
  };
};
